module.exports = __webpack_public_path__ + "static/media/ic_mail_list.3198d902.png";